export const featurePath = '/v4/support/validation';

export const featureKeys = {
  email: [{ scope: 'email-validator' }] as const,
};
